import {coreApi} from './core'

export const empowermentService = {
    async getCompanyById(params) {
        return await coreApi.get(`empow/company`, {params})
    },
    async getById(id) {
        return await coreApi.get(`empow?id=${id}`)
    },
    async getAll() {
        return await coreApi.get(`empow/`)
    },
    async create(data) {
        return await coreApi.post(`empow/`, data)
    },
    async update(data) {
        return await coreApi.put(`empow/`, data)
    },
    delete: async (id) => coreApi.delete(`empow/${id}`),
    paginate: async (offset) => coreApi.get(`empow/${offset}`),

}
